module.exports = __webpack_public_path__ + "static/media/play_ip.ff636c26.svg";